import { defineAsyncComponent } from "vue";

export default {
    sectionContainer: defineAsyncComponent(() => import("./SectionContainer.vue")),
    webButton: defineAsyncComponent(() => import("./WebButton.vue")),
    heroContent: defineAsyncComponent(() => import("./HeroContent.vue")),
    card: defineAsyncComponent(() => import("./Card.vue")),
    tokens: {
        // Cards are dark (bg-neutral-900/950) — override the default
        // near-black heading/body/muted tiers with light equivalents.
        "--theme-text-heading": "#ffffff",
        "--theme-text-body": "#e5e5e5",
        "--theme-text-muted": "#a3a3a3",
    },
};
